<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'General' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <user-general />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-layers" :label="!isSmallerScreen ? 'Venues' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <user-venues />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-link" :label="!isSmallerScreen ? 'Planday' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <user-planday />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import UserGeneral from './UserGeneral.vue'
import UserVenues from './UserVenues.vue'
import UserPlanday from './UserPlanday.vue'

export default {
  components: {
    UserGeneral,
    UserVenues,
    UserPlanday
  },
  data () {
    return {

    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
